import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/style.scss';
import App from './App';
import {BrowserRouter as Router}  from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Router><HelmetProvider>
    <App />
  </HelmetProvider></Router>);
